import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 input-daterange input-group maisaiToolsRow" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12 btn-group btn-group-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Mo_modal_l = _resolveComponent("Mo_modal_l")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "meisaiToolsTitle" }, "【売上】分割計上総額", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("input", {
          type: "text",
          name: "txtSalesSum",
          maxlength: "10",
          class: "form-control form-control-sm",
          id: "txtSalesSum",
          style: {"max-width":"130px","min-width":"50px","text-align":"right"}
        }, null, -1)),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "meisaiToolsTitle" }, "項目", -1)),
        _createVNode(_component_vSelect, {
          class: "meisiTools-select",
          style: {"max-width":"130px","min-width":"40px"},
          options: _ctx.optionsOp4
        }, null, 8, ["options"]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "meisaiToolsTitle" }, "科目", -1)),
        _createVNode(_component_vSelect, {
          class: "meisiTools-select",
          style: {"max-width":"130px","min-width":"60px"},
          options: _ctx.optionsOp5
        }, null, 8, ["options"]),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "meisaiToolsTitle" }, "内訳", -1)),
        _createVNode(_component_vSelect, {
          class: "meisiTools-select",
          style: {"max-width":"130px","min-width":"60px"},
          options: _ctx.optionsOp6
        }, null, 8, ["options"]),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "meisaiToolsTitle" }, "売上先", -1)),
        _createVNode(_component_vSelect, {
          class: "meisiTools-select",
          style: {"min-width":"50px","max-width":"250px"},
          options: _ctx.optionsOp
        }, null, 8, ["options"]),
        _cache[9] || (_cache[9] = _createElementVNode("input", {
          type: "button",
          value: "分割",
          class: "form-control form-control-sm meisaiToolsBtn btn-default",
          style: {"max-width":"60px","margin-left":"10px","border-radius":"4px"},
          id: "splitSales"
        }, null, -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[10] || (_cache[10] = _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed"
        }, " 売上明細行追加 ", -1)),
        _cache[11] || (_cache[11] = _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed"
        }, " 売上明細行削除 ", -1)),
        _cache[12] || (_cache[12] = _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed"
        }, " 売上明細選択行削除 ", -1)),
        _cache[13] || (_cache[13] = _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed"
        }, " 行コピー ", -1)),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal()))
        }, " 請求NR取得 ")
      ])
    ]),
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "row ditTableFrame" }, [
      _createElementVNode("table", {
        class: "sales_list",
        id: "sales_list",
        style: {"margin":"0px","padding":"0px","width":"100%"}
      }, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { class: "fixhead headUriage cwU_1" }, "行No"),
            _createElementVNode("th", { class: "fixhead headUriage cwU_2" }, "請求No"),
            _createElementVNode("th", { class: "fixhead headUriage cwU_3" }, "請求日"),
            _createElementVNode("th", { class: "fixhead headUriage cwU_4" }, "売上月"),
            _createElementVNode("th", { class: "fixhead headUriage cwU_5" }, "項目"),
            _createElementVNode("th", { class: "fixhead headUriage cwU_6" }, "科目"),
            _createElementVNode("th", { class: "fixhead headUriage cwU_7" }, "内訳"),
            _createElementVNode("th", { class: "fixhead headUriage cwU_8" }, "売上先"),
            _createElementVNode("th", { class: "fixhead headUriage cwU_9" }, "金額"),
            _createElementVNode("th", { class: "fixhead headUriage cwU_10" }, "消費税"),
            _createElementVNode("th", { class: "fixhead headUriage cwU_11" }, "入金予定日"),
            _createElementVNode("th", { class: "fixhead headUriage cwU_12" }, "入金完了日"),
            _createElementVNode("th", { class: "fixhead headUriage cwU_13" }, "備考")
          ])
        ]),
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", { class: "salesrow" }, [
            _createElementVNode("td", {
              style: {"text-align":"center"},
              class: "GYONO meisaiCont cwU_1"
            }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1GYO_NO",
                id: "Sales1GYO_NO",
                maxlength: "3",
                class: "example3",
                readonly: "true",
                value: "1"
              })
            ]),
            _createElementVNode("td", {
              style: {"text-align":"center"},
              class: "CLAIMNO meisaiCont cwU_2"
            }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1CLAIM_NO",
                id: "Sales1CLAIM_NO",
                maxlength: "10",
                class: "example3",
                value: "10962"
              })
            ]),
            _createElementVNode("td", { class: "CLAIM_DATE meisaiCont cwU_3" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1CLAIM_DATE",
                id: "Sales1CLAIM_DATE",
                maxlength: "10",
                class: "datepicker example3 hasDatepicker",
                value: "2022/12/26"
              })
            ]),
            _createElementVNode("td", { class: "SALESMONTH meisaiCont cwU_4" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1SALES_MONTH",
                id: "Sales1SALES_MONTH",
                maxlength: "7",
                class: "datepickerYearMonth example3 hasDatepicker",
                value: "2023/01"
              })
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "ITEMIZE meisaiCont cwU_5"
            }, [
              _createElementVNode("select", {
                name: "Sales1ITEMIZE",
                id: "Sales1ITEMIZE"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "1",
                  selected: "true"
                }, "新規"),
                _createElementVNode("option", { value: "2" }, "継続")
              ])
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "COURSE meisaiCont cwU_6"
            }, [
              _createElementVNode("select", {
                name: "Sales1COURSE",
                id: "Sales1COURSE"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "1",
                  selected: "true"
                }, "長期看板"),
                _createElementVNode("option", { value: "2" }, "短期看板"),
                _createElementVNode("option", { value: "3" }, "リムジンバス"),
                _createElementVNode("option", { value: "4" }, "都営交通"),
                _createElementVNode("option", { value: "5" }, "交通広告"),
                _createElementVNode("option", { value: "6" }, "ビジョン"),
                _createElementVNode("option", { value: "7" }, "経費"),
                _createElementVNode("option", { value: "8" }, "その他")
              ])
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "BREAK_DOWN cwU_7"
            }, [
              _createElementVNode("select", {
                name: "Sales1BREAK_DOWN",
                id: "Sales1BREAK_DOWN"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "1",
                  selected: "true"
                }, "媒体料"),
                _createElementVNode("option", { value: "2" }, "プリント"),
                _createElementVNode("option", { value: "3" }, "施工"),
                _createElementVNode("option", { value: "4" }, "製作施工"),
                _createElementVNode("option", { value: "5" }, "工事(資産)"),
                _createElementVNode("option", { value: "6" }, "保険・申請"),
                _createElementVNode("option", { value: "7" }, "撤去前受"),
                _createElementVNode("option", { value: "8" }, "その他")
              ])
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "SALES_CD meisaiCont cwU_8"
            }, [
              _createElementVNode("select", {
                name: "Sales1SALES_CD",
                id: "Sales1SALES_CD"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "308",
                  selected: "true"
                }, "AIADテスト"),
                _createElementVNode("option", { value: "323" }, "アスリン"),
                _createElementVNode("option", { value: "271" }, "アドインテ"),
                _createElementVNode("option", { value: "316" }, "アドセブンスリー"),
                _createElementVNode("option", { value: "346" }, "アドフロンテ"),
                _createElementVNode("option", { value: "335" }, "AbemaTV"),
                _createElementVNode("option", { value: "293" }, "アルビオン"),
                _createElementVNode("option", { value: "306" }, "アルファトラスト"),
                _createElementVNode("option", { value: "317" }, "医療法人社団新正会　安藤歯科医院")
              ])
            ]),
            _createElementVNode("td", {
              class: "SUM meisaiCont cwU_9",
              id: "Sales_SUM_1"
            }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1SUM",
                style: {"text-align":"right"},
                id: "Sales1SUM",
                maxlength: "10",
                class: "example3",
                onfocus: "kanmaDel(this)",
                onblur: "kanmaIns(this)",
                value: "10,000"
              })
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "SYOHIZEI_RITU meisaiCont cwU_10"
            }, [
              _createElementVNode("select", {
                name: "Sales1SYOHIZEI_RITU",
                id: "Sales1SYOHIZEI_RITU"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", { value: "1" }, "5%"),
                _createElementVNode("option", { value: "2" }, "8%"),
                _createElementVNode("option", {
                  value: "3",
                  selected: "true"
                }, "10%")
              ])
            ]),
            _createElementVNode("td", { class: "NYUKIN_YOTEI_DATE meisaiCont cwU_11" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1NYUKIN_YOTEI_DATE",
                id: "Sales1NYUKIN_YOTEI_DATE",
                maxlength: "10",
                class: "datepicker example3 hasDatepicker",
                value: ""
              })
            ]),
            _createElementVNode("td", { class: "NYUKIN_DATE meisaiCont cwU_12" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1NYUKIN_DATE",
                id: "Sales1NYUKIN_DATE",
                maxlength: "10",
                class: "datepicker example3 hasDatepicker",
                value: ""
              })
            ]),
            _createElementVNode("td", { class: "BIKO meisaiCont cwU_13" }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1BIKO",
                id: "Sales1BIKO",
                maxlength: "1000",
                class: "example2",
                value: ""
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1USER_NM",
                id: "Sales1USER_NM",
                value: "権限確認：集計者"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1UPDATE_DATE",
                id: "Sales1UPDATE_DATE",
                value: "23/01/16 14:18"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1LOCK_FLG",
                id: "Sales1LOCK_FLG",
                value: "0"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1CHANGE_FLG",
                id: "Sales1CHANGE_FLG",
                value: "0"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1SALES_NO",
                id: "Sales1SALES_NO",
                value: "1"
              })
            ])
          ]),
          _createElementVNode("tr", { class: "salesrow" }, [
            _createElementVNode("td", {
              style: {"text-align":"center"},
              class: "GYONO meisaiCont cwU_1"
            }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1GYO_NO",
                id: "Sales1GYO_NO",
                maxlength: "3",
                class: "example3",
                readonly: "true",
                value: "2"
              })
            ]),
            _createElementVNode("td", {
              style: {"text-align":"center"},
              class: "CLAIMNO meisaiCont cwU_2"
            }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1CLAIM_NO",
                id: "Sales1CLAIM_NO",
                maxlength: "10",
                class: "example3",
                value: "10962"
              })
            ]),
            _createElementVNode("td", { class: "CLAIM_DATE meisaiCont cwU_3" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1CLAIM_DATE",
                id: "Sales1CLAIM_DATE",
                maxlength: "10",
                class: "datepicker example3 hasDatepicker",
                value: "2022/12/26"
              })
            ]),
            _createElementVNode("td", { class: "SALESMONTH meisaiCont cwU_4" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1SALES_MONTH",
                id: "Sales1SALES_MONTH",
                maxlength: "7",
                class: "datepickerYearMonth example3 hasDatepicker",
                value: "2023/01"
              })
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "ITEMIZE meisaiCont cwU_5"
            }, [
              _createElementVNode("select", {
                name: "Sales1ITEMIZE",
                id: "Sales1ITEMIZE"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "1",
                  selected: "true"
                }, "新規"),
                _createElementVNode("option", { value: "2" }, "継続")
              ])
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "COURSE meisaiCont cwU_6"
            }, [
              _createElementVNode("select", {
                name: "Sales1COURSE",
                id: "Sales1COURSE"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "1",
                  selected: "true"
                }, "長期看板"),
                _createElementVNode("option", { value: "2" }, "短期看板"),
                _createElementVNode("option", { value: "3" }, "リムジンバス"),
                _createElementVNode("option", { value: "4" }, "都営交通"),
                _createElementVNode("option", { value: "5" }, "交通広告"),
                _createElementVNode("option", { value: "6" }, "ビジョン"),
                _createElementVNode("option", { value: "7" }, "経費"),
                _createElementVNode("option", { value: "8" }, "その他")
              ])
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "BREAK_DOWN cwU_7"
            }, [
              _createElementVNode("select", {
                name: "Sales1BREAK_DOWN",
                id: "Sales1BREAK_DOWN"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "1",
                  selected: "true"
                }, "媒体料"),
                _createElementVNode("option", { value: "2" }, "プリント"),
                _createElementVNode("option", { value: "3" }, "施工"),
                _createElementVNode("option", { value: "4" }, "製作施工"),
                _createElementVNode("option", { value: "5" }, "工事(資産)"),
                _createElementVNode("option", { value: "6" }, "保険・申請"),
                _createElementVNode("option", { value: "7" }, "撤去前受"),
                _createElementVNode("option", { value: "8" }, "その他")
              ])
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "SALES_CD meisaiCont cwU_8"
            }, [
              _createElementVNode("select", {
                name: "Sales1SALES_CD",
                id: "Sales1SALES_CD"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "308",
                  selected: "true"
                }, "AIADテスト"),
                _createElementVNode("option", { value: "323" }, "アスリン"),
                _createElementVNode("option", { value: "271" }, "アドインテ"),
                _createElementVNode("option", { value: "316" }, "アドセブンスリー"),
                _createElementVNode("option", { value: "346" }, "アドフロンテ"),
                _createElementVNode("option", { value: "335" }, "AbemaTV"),
                _createElementVNode("option", { value: "293" }, "アルビオン"),
                _createElementVNode("option", { value: "306" }, "アルファトラスト"),
                _createElementVNode("option", { value: "317" }, "医療法人社団新正会　安藤歯科医院")
              ])
            ]),
            _createElementVNode("td", {
              class: "SUM meisaiCont cwU_9",
              id: "Sales_SUM_1"
            }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1SUM",
                style: {"text-align":"right"},
                id: "Sales1SUM",
                maxlength: "10",
                class: "example3",
                onfocus: "kanmaDel(this)",
                onblur: "kanmaIns(this)",
                value: "10,000"
              })
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "SYOHIZEI_RITU meisaiCont cwU_10"
            }, [
              _createElementVNode("select", {
                name: "Sales1SYOHIZEI_RITU",
                id: "Sales1SYOHIZEI_RITU"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", { value: "1" }, "5%"),
                _createElementVNode("option", { value: "2" }, "8%"),
                _createElementVNode("option", {
                  value: "3",
                  selected: "true"
                }, "10%")
              ])
            ]),
            _createElementVNode("td", { class: "NYUKIN_YOTEI_DATE meisaiCont cwU_11" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1NYUKIN_YOTEI_DATE",
                id: "Sales1NYUKIN_YOTEI_DATE",
                maxlength: "10",
                class: "datepicker example3 hasDatepicker",
                value: ""
              })
            ]),
            _createElementVNode("td", { class: "NYUKIN_DATE meisaiCont cwU_12" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1NYUKIN_DATE",
                id: "Sales1NYUKIN_DATE",
                maxlength: "10",
                class: "datepicker example3 hasDatepicker",
                value: ""
              })
            ]),
            _createElementVNode("td", { class: "BIKO meisaiCont cwU_13" }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1BIKO",
                id: "Sales1BIKO",
                maxlength: "1000",
                class: "example2",
                value: ""
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1USER_NM",
                id: "Sales1USER_NM",
                value: "権限確認：集計者"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1UPDATE_DATE",
                id: "Sales1UPDATE_DATE",
                value: "23/01/16 14:18"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1LOCK_FLG",
                id: "Sales1LOCK_FLG",
                value: "0"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1CHANGE_FLG",
                id: "Sales1CHANGE_FLG",
                value: "0"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1SALES_NO",
                id: "Sales1SALES_NO",
                value: "1"
              })
            ])
          ]),
          _createElementVNode("tr", { class: "salesrow" }, [
            _createElementVNode("td", {
              style: {"text-align":"center"},
              class: "GYONO meisaiCont cwU_1"
            }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1GYO_NO",
                id: "Sales1GYO_NO",
                maxlength: "3",
                class: "example3",
                readonly: "true",
                value: "3"
              })
            ]),
            _createElementVNode("td", {
              style: {"text-align":"center"},
              class: "CLAIMNO meisaiCont cwU_2"
            }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1CLAIM_NO",
                id: "Sales1CLAIM_NO",
                maxlength: "10",
                class: "example3",
                value: "10962"
              })
            ]),
            _createElementVNode("td", { class: "CLAIM_DATE meisaiCont cwU_3" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1CLAIM_DATE",
                id: "Sales1CLAIM_DATE",
                maxlength: "10",
                class: "datepicker example3 hasDatepicker",
                value: "2022/12/26"
              })
            ]),
            _createElementVNode("td", { class: "SALESMONTH meisaiCont cwU_4" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1SALES_MONTH",
                id: "Sales1SALES_MONTH",
                maxlength: "7",
                class: "datepickerYearMonth example3 hasDatepicker",
                value: "2023/01"
              })
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "ITEMIZE meisaiCont cwU_5"
            }, [
              _createElementVNode("select", {
                name: "Sales1ITEMIZE",
                id: "Sales1ITEMIZE"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "1",
                  selected: "true"
                }, "新規"),
                _createElementVNode("option", { value: "2" }, "継続")
              ])
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "COURSE meisaiCont cwU_6"
            }, [
              _createElementVNode("select", {
                name: "Sales1COURSE",
                id: "Sales1COURSE"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "1",
                  selected: "true"
                }, "長期看板"),
                _createElementVNode("option", { value: "2" }, "短期看板"),
                _createElementVNode("option", { value: "3" }, "リムジンバス"),
                _createElementVNode("option", { value: "4" }, "都営交通"),
                _createElementVNode("option", { value: "5" }, "交通広告"),
                _createElementVNode("option", { value: "6" }, "ビジョン"),
                _createElementVNode("option", { value: "7" }, "経費"),
                _createElementVNode("option", { value: "8" }, "その他")
              ])
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "BREAK_DOWN cwU_7"
            }, [
              _createElementVNode("select", {
                name: "Sales1BREAK_DOWN",
                id: "Sales1BREAK_DOWN"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "1",
                  selected: "true"
                }, "媒体料"),
                _createElementVNode("option", { value: "2" }, "プリント"),
                _createElementVNode("option", { value: "3" }, "施工"),
                _createElementVNode("option", { value: "4" }, "製作施工"),
                _createElementVNode("option", { value: "5" }, "工事(資産)"),
                _createElementVNode("option", { value: "6" }, "保険・申請"),
                _createElementVNode("option", { value: "7" }, "撤去前受"),
                _createElementVNode("option", { value: "8" }, "その他")
              ])
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "SALES_CD meisaiCont cwU_8"
            }, [
              _createElementVNode("select", {
                name: "Sales1SALES_CD",
                id: "Sales1SALES_CD"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "308",
                  selected: "true"
                }, "AIADテスト"),
                _createElementVNode("option", { value: "323" }, "アスリン"),
                _createElementVNode("option", { value: "271" }, "アドインテ"),
                _createElementVNode("option", { value: "316" }, "アドセブンスリー"),
                _createElementVNode("option", { value: "346" }, "アドフロンテ"),
                _createElementVNode("option", { value: "335" }, "AbemaTV"),
                _createElementVNode("option", { value: "293" }, "アルビオン"),
                _createElementVNode("option", { value: "306" }, "アルファトラスト"),
                _createElementVNode("option", { value: "317" }, "医療法人社団新正会　安藤歯科医院")
              ])
            ]),
            _createElementVNode("td", {
              class: "SUM meisaiCont cwU_9",
              id: "Sales_SUM_1"
            }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1SUM",
                style: {"text-align":"right"},
                id: "Sales1SUM",
                maxlength: "10",
                class: "example3",
                onfocus: "kanmaDel(this)",
                onblur: "kanmaIns(this)",
                value: "10,000"
              })
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "SYOHIZEI_RITU meisaiCont cwU_10"
            }, [
              _createElementVNode("select", {
                name: "Sales1SYOHIZEI_RITU",
                id: "Sales1SYOHIZEI_RITU"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", { value: "1" }, "5%"),
                _createElementVNode("option", { value: "2" }, "8%"),
                _createElementVNode("option", {
                  value: "3",
                  selected: "true"
                }, "10%")
              ])
            ]),
            _createElementVNode("td", { class: "NYUKIN_YOTEI_DATE meisaiCont cwU_11" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1NYUKIN_YOTEI_DATE",
                id: "Sales1NYUKIN_YOTEI_DATE",
                maxlength: "10",
                class: "datepicker example3 hasDatepicker",
                value: ""
              })
            ]),
            _createElementVNode("td", { class: "NYUKIN_DATE meisaiCont cwU_12" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1NYUKIN_DATE",
                id: "Sales1NYUKIN_DATE",
                maxlength: "10",
                class: "datepicker example3 hasDatepicker",
                value: ""
              })
            ]),
            _createElementVNode("td", { class: "BIKO meisaiCont cwU_13" }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1BIKO",
                id: "Sales1BIKO",
                maxlength: "1000",
                class: "example2",
                value: ""
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1USER_NM",
                id: "Sales1USER_NM",
                value: "権限確認：集計者"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1UPDATE_DATE",
                id: "Sales1UPDATE_DATE",
                value: "23/01/16 14:18"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1LOCK_FLG",
                id: "Sales1LOCK_FLG",
                value: "0"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1CHANGE_FLG",
                id: "Sales1CHANGE_FLG",
                value: "0"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1SALES_NO",
                id: "Sales1SALES_NO",
                value: "1"
              })
            ])
          ]),
          _createElementVNode("tr", { class: "salesrow" }, [
            _createElementVNode("td", {
              style: {"text-align":"center"},
              class: "GYONO meisaiCont cwU_1"
            }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1GYO_NO",
                id: "Sales1GYO_NO",
                maxlength: "3",
                class: "example3",
                readonly: "true",
                value: "4"
              })
            ]),
            _createElementVNode("td", {
              style: {"text-align":"center"},
              class: "CLAIMNO meisaiCont cwU_2"
            }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1CLAIM_NO",
                id: "Sales1CLAIM_NO",
                maxlength: "10",
                class: "example3",
                value: "10962"
              })
            ]),
            _createElementVNode("td", { class: "CLAIM_DATE meisaiCont cwU_3" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1CLAIM_DATE",
                id: "Sales1CLAIM_DATE",
                maxlength: "10",
                class: "datepicker example3 hasDatepicker",
                value: "2022/12/26"
              })
            ]),
            _createElementVNode("td", { class: "SALESMONTH meisaiCont cwU_4" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1SALES_MONTH",
                id: "Sales1SALES_MONTH",
                maxlength: "7",
                class: "datepickerYearMonth example3 hasDatepicker",
                value: "2023/01"
              })
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "ITEMIZE meisaiCont cwU_5"
            }, [
              _createElementVNode("select", {
                name: "Sales1ITEMIZE",
                id: "Sales1ITEMIZE"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "1",
                  selected: "true"
                }, "新規"),
                _createElementVNode("option", { value: "2" }, "継続")
              ])
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "COURSE meisaiCont cwU_6"
            }, [
              _createElementVNode("select", {
                name: "Sales1COURSE",
                id: "Sales1COURSE"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "1",
                  selected: "true"
                }, "長期看板"),
                _createElementVNode("option", { value: "2" }, "短期看板"),
                _createElementVNode("option", { value: "3" }, "リムジンバス"),
                _createElementVNode("option", { value: "4" }, "都営交通"),
                _createElementVNode("option", { value: "5" }, "交通広告"),
                _createElementVNode("option", { value: "6" }, "ビジョン"),
                _createElementVNode("option", { value: "7" }, "経費"),
                _createElementVNode("option", { value: "8" }, "その他")
              ])
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "BREAK_DOWN cwU_7"
            }, [
              _createElementVNode("select", {
                name: "Sales1BREAK_DOWN",
                id: "Sales1BREAK_DOWN"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "1",
                  selected: "true"
                }, "媒体料"),
                _createElementVNode("option", { value: "2" }, "プリント"),
                _createElementVNode("option", { value: "3" }, "施工"),
                _createElementVNode("option", { value: "4" }, "製作施工"),
                _createElementVNode("option", { value: "5" }, "工事(資産)"),
                _createElementVNode("option", { value: "6" }, "保険・申請"),
                _createElementVNode("option", { value: "7" }, "撤去前受"),
                _createElementVNode("option", { value: "8" }, "その他")
              ])
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "SALES_CD meisaiCont cwU_8"
            }, [
              _createElementVNode("select", {
                name: "Sales1SALES_CD",
                id: "Sales1SALES_CD"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "308",
                  selected: "true"
                }, "AIADテスト"),
                _createElementVNode("option", { value: "323" }, "アスリン"),
                _createElementVNode("option", { value: "271" }, "アドインテ"),
                _createElementVNode("option", { value: "316" }, "アドセブンスリー"),
                _createElementVNode("option", { value: "346" }, "アドフロンテ"),
                _createElementVNode("option", { value: "335" }, "AbemaTV"),
                _createElementVNode("option", { value: "293" }, "アルビオン"),
                _createElementVNode("option", { value: "306" }, "アルファトラスト"),
                _createElementVNode("option", { value: "317" }, "医療法人社団新正会　安藤歯科医院")
              ])
            ]),
            _createElementVNode("td", {
              class: "SUM meisaiCont cwU_9",
              id: "Sales_SUM_1"
            }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1SUM",
                style: {"text-align":"right"},
                id: "Sales1SUM",
                maxlength: "10",
                class: "example3",
                onfocus: "kanmaDel(this)",
                onblur: "kanmaIns(this)",
                value: "10,000"
              })
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "SYOHIZEI_RITU meisaiCont cwU_10"
            }, [
              _createElementVNode("select", {
                name: "Sales1SYOHIZEI_RITU",
                id: "Sales1SYOHIZEI_RITU"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", { value: "1" }, "5%"),
                _createElementVNode("option", { value: "2" }, "8%"),
                _createElementVNode("option", {
                  value: "3",
                  selected: "true"
                }, "10%")
              ])
            ]),
            _createElementVNode("td", { class: "NYUKIN_YOTEI_DATE meisaiCont cwU_11" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1NYUKIN_YOTEI_DATE",
                id: "Sales1NYUKIN_YOTEI_DATE",
                maxlength: "10",
                class: "datepicker example3 hasDatepicker",
                value: ""
              })
            ]),
            _createElementVNode("td", { class: "NYUKIN_DATE meisaiCont cwU_12" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1NYUKIN_DATE",
                id: "Sales1NYUKIN_DATE",
                maxlength: "10",
                class: "datepicker example3 hasDatepicker",
                value: ""
              })
            ]),
            _createElementVNode("td", { class: "BIKO meisaiCont cwU_13" }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1BIKO",
                id: "Sales1BIKO",
                maxlength: "1000",
                class: "example2",
                value: ""
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1USER_NM",
                id: "Sales1USER_NM",
                value: "権限確認：集計者"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1UPDATE_DATE",
                id: "Sales1UPDATE_DATE",
                value: "23/01/16 14:18"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1LOCK_FLG",
                id: "Sales1LOCK_FLG",
                value: "0"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1CHANGE_FLG",
                id: "Sales1CHANGE_FLG",
                value: "0"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1SALES_NO",
                id: "Sales1SALES_NO",
                value: "1"
              })
            ])
          ]),
          _createElementVNode("tr", { class: "salesrow" }, [
            _createElementVNode("td", {
              style: {"text-align":"center"},
              class: "GYONO meisaiCont cwU_1"
            }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1GYO_NO",
                id: "Sales1GYO_NO",
                maxlength: "3",
                class: "example3",
                readonly: "true",
                value: "5"
              })
            ]),
            _createElementVNode("td", {
              style: {"text-align":"center"},
              class: "CLAIMNO meisaiCont cwU_2"
            }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1CLAIM_NO",
                id: "Sales1CLAIM_NO",
                maxlength: "10",
                class: "example3",
                value: "10962"
              })
            ]),
            _createElementVNode("td", { class: "CLAIM_DATE meisaiCont cwU_3" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1CLAIM_DATE",
                id: "Sales1CLAIM_DATE",
                maxlength: "10",
                class: "datepicker example3 hasDatepicker",
                value: "2022/12/26"
              })
            ]),
            _createElementVNode("td", { class: "SALESMONTH meisaiCont cwU_4" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1SALES_MONTH",
                id: "Sales1SALES_MONTH",
                maxlength: "7",
                class: "datepickerYearMonth example3 hasDatepicker",
                value: "2023/01"
              })
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "ITEMIZE meisaiCont cwU_5"
            }, [
              _createElementVNode("select", {
                name: "Sales1ITEMIZE",
                id: "Sales1ITEMIZE"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "1",
                  selected: "true"
                }, "新規"),
                _createElementVNode("option", { value: "2" }, "継続")
              ])
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "COURSE meisaiCont cwU_6"
            }, [
              _createElementVNode("select", {
                name: "Sales1COURSE",
                id: "Sales1COURSE"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "1",
                  selected: "true"
                }, "長期看板"),
                _createElementVNode("option", { value: "2" }, "短期看板"),
                _createElementVNode("option", { value: "3" }, "リムジンバス"),
                _createElementVNode("option", { value: "4" }, "都営交通"),
                _createElementVNode("option", { value: "5" }, "交通広告"),
                _createElementVNode("option", { value: "6" }, "ビジョン"),
                _createElementVNode("option", { value: "7" }, "経費"),
                _createElementVNode("option", { value: "8" }, "その他")
              ])
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "BREAK_DOWN cwU_7"
            }, [
              _createElementVNode("select", {
                name: "Sales1BREAK_DOWN",
                id: "Sales1BREAK_DOWN"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "1",
                  selected: "true"
                }, "媒体料"),
                _createElementVNode("option", { value: "2" }, "プリント"),
                _createElementVNode("option", { value: "3" }, "施工"),
                _createElementVNode("option", { value: "4" }, "製作施工"),
                _createElementVNode("option", { value: "5" }, "工事(資産)"),
                _createElementVNode("option", { value: "6" }, "保険・申請"),
                _createElementVNode("option", { value: "7" }, "撤去前受"),
                _createElementVNode("option", { value: "8" }, "その他")
              ])
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "SALES_CD meisaiCont cwU_8"
            }, [
              _createElementVNode("select", {
                name: "Sales1SALES_CD",
                id: "Sales1SALES_CD"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", {
                  value: "308",
                  selected: "true"
                }, "AIADテスト"),
                _createElementVNode("option", { value: "323" }, "アスリン"),
                _createElementVNode("option", { value: "271" }, "アドインテ"),
                _createElementVNode("option", { value: "316" }, "アドセブンスリー"),
                _createElementVNode("option", { value: "346" }, "アドフロンテ"),
                _createElementVNode("option", { value: "335" }, "AbemaTV"),
                _createElementVNode("option", { value: "293" }, "アルビオン"),
                _createElementVNode("option", { value: "306" }, "アルファトラスト"),
                _createElementVNode("option", { value: "317" }, "医療法人社団新正会　安藤歯科医院")
              ])
            ]),
            _createElementVNode("td", {
              class: "SUM meisaiCont cwU_9",
              id: "Sales_SUM_1"
            }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1SUM",
                style: {"text-align":"right"},
                id: "Sales1SUM",
                maxlength: "10",
                class: "example3",
                onfocus: "kanmaDel(this)",
                onblur: "kanmaIns(this)",
                value: "10,000"
              })
            ]),
            _createElementVNode("td", {
              style: {"text-align":"left"},
              class: "SYOHIZEI_RITU meisaiCont cwU_10"
            }, [
              _createElementVNode("select", {
                name: "Sales1SYOHIZEI_RITU",
                id: "Sales1SYOHIZEI_RITU"
              }, [
                _createElementVNode("option", { value: "" }),
                _createElementVNode("option", { value: "1" }, "5%"),
                _createElementVNode("option", { value: "2" }, "8%"),
                _createElementVNode("option", {
                  value: "3",
                  selected: "true"
                }, "10%")
              ])
            ]),
            _createElementVNode("td", { class: "NYUKIN_YOTEI_DATE meisaiCont cwU_11" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1NYUKIN_YOTEI_DATE",
                id: "Sales1NYUKIN_YOTEI_DATE",
                maxlength: "10",
                class: "datepicker example3 hasDatepicker",
                value: ""
              })
            ]),
            _createElementVNode("td", { class: "NYUKIN_DATE meisaiCont cwU_12" }, [
              _createElementVNode("input", {
                type: "date",
                name: "Sales1NYUKIN_DATE",
                id: "Sales1NYUKIN_DATE",
                maxlength: "10",
                class: "datepicker example3 hasDatepicker",
                value: ""
              })
            ]),
            _createElementVNode("td", { class: "BIKO meisaiCont cwU_13" }, [
              _createElementVNode("input", {
                type: "text",
                name: "Sales1BIKO",
                id: "Sales1BIKO",
                maxlength: "1000",
                class: "example2",
                value: ""
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1USER_NM",
                id: "Sales1USER_NM",
                value: "権限確認：集計者"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1UPDATE_DATE",
                id: "Sales1UPDATE_DATE",
                value: "23/01/16 14:18"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1LOCK_FLG",
                id: "Sales1LOCK_FLG",
                value: "0"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1CHANGE_FLG",
                id: "Sales1CHANGE_FLG",
                value: "0"
              }),
              _createElementVNode("input", {
                type: "hidden",
                name: "Sales1SALES_NO",
                id: "Sales1SALES_NO",
                value: "1"
              })
            ])
          ])
        ])
      ])
    ], -1)),
    _createVNode(_component_Mo_modal_l, { ref: "Mo_modal_nrGet" }, {
      title: _withCtx(() => _cache[14] || (_cache[14] = [
        _createTextVNode("請求書NR取得")
      ])),
      body: _withCtx(() => _cache[15] || (_cache[15] = [
        _createElementVNode("div", { class: "row" }, [
          _createElementVNode("div", { class: "col-md-2 contTitle" }, "案件番号"),
          _createElementVNode("div", { class: "col-md-10 contCnt" }, [
            _createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              disabled: ""
            })
          ])
        ], -1),
        _createElementVNode("div", { class: "row" }, [
          _createElementVNode("div", { class: "col-md-2 contTitle" }, "案件名"),
          _createElementVNode("div", { class: "col-md-10 contCnt" }, [
            _createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              disabled: ""
            })
          ])
        ], -1),
        _createElementVNode("div", { class: "row" }, [
          _createElementVNode("div", { class: "col-md-2 contTitle" }, "請求番号"),
          _createElementVNode("div", { class: "col-md-10 contTitle" }, "メモ")
        ], -1),
        _createElementVNode("div", { class: "row" }, [
          _createElementVNode("div", { class: "col-md-2 contTitle" }, [
            _createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              disabled: ""
            })
          ]),
          _createElementVNode("div", { class: "col-md-10 contCnt" }, [
            _createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm"
            })
          ])
        ], -1),
        _createElementVNode("div", { class: "row mt-5 ml-auto demo" }, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary waves-effect waves-themed"
          }, " 請求番号欄追加 "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary waves-effect waves-themed"
          }, " 請求番号欄削除 ")
        ], -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-info waves-effect waves-themed",
          "data-dismiss": "modal",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModal()))
        }, _cache[16] || (_cache[16] = [
          _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
          _createTextVNode(" 登録 ")
        ])),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          "data-dismiss": "modal",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeModal()))
        }, " 閉じる ")
      ]),
      _: 1
    }, 512)
  ]))
}